"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberFormat = void 0;
var _react = _interopRequireDefault(require("react"));
var _decimal = _interopRequireDefault(require("decimal.js"));
var _definitions = require("@ppay/definitions");
var _ui = require("../ui");
var _constants = require("../../constants");
var _excluded = ["value", "ticker"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var NumberFormat = function NumberFormat(_ref) {
  var value = _ref.value,
    ticker = _ref.ticker,
    props = _objectWithoutProperties(_ref, _excluded);
  var dScale = _constants.TickerDecimals[ticker];
  var dValue = new _decimal.default(value);
  return /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, _extends({
    trimZeros: true,
    value: value,
    decimals: ticker !== _definitions.Ticker.USD && dValue.abs().lt(Math.pow(10, -dScale)) ? dValue.decimalPlaces() : dScale
  }, props));
};
exports.NumberFormat = NumberFormat;